export const AUTHENTICATION_CONNECTION = 'B2XCORE_AUTHENTICATION';

export const JWS_ENTRY = 'ow_aem_jws';
